import FullLogo from 'assets/images/full-logo-blockchain-lightblue.svg'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.img`
  margin-left: 2rem;
`

const ExchangeLogo = () => <Wrapper src={FullLogo} width={444} />

export default ExchangeLogo
